import { render, staticRenderFns } from "./TabbedModal.vue?vue&type=template&id=3040a33a"
import script from "./TabbedModal.vue?vue&type=script&lang=js"
export * from "./TabbedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports